/** Short display label — prefers name, then text before ":", never the full brochure copy. */
export function vehicleTypeLabel(type: {
  name?: string | null;
  description?: string | null;
}): string {
  const name = type.name?.trim();
  if (name) return name;

  const description = type.description?.trim();
  if (!description) return "—";

  const colonIdx = description.indexOf(":");
  if (colonIdx > 0 && colonIdx < 48) {
    return description.slice(0, colonIdx).trim();
  }

  // "People Carrier VW Sharan..." without a colon — take first 2–3 title-case words
  const titleMatch = description.match(
    /^(Executive\s+People\s+Carrier|People\s+Carrier|Executive\s+Car|Estate\s+Car|Saloon\s+Car|8\s+Seater\s+Minibus|Estate|Saloon)(?:\b|$)/i,
  );
  if (titleMatch) return titleMatch[1];

  if (description.length > 36) return `${description.slice(0, 33).trimEnd()}…`;
  return description;
}

/** Shorten a stored vehicle type name string (e.g. on bookings) to a compact label. */
export function shortenVehicleTypeName(value?: string | null): string {
  const text = value?.trim();
  if (!text) return "—";
  return vehicleTypeLabel({ description: text });
}
